import logo from './logo.svg';
import './App.css';
import BankApp from './BankApp.js';

function App() {
  return (
    <div className="App">
      <BankApp/>
    </div>
  );
}

export default App;
